import React from 'react';

import { homecleanState } from 'atoms';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';

import Button from '@components/common/Button';
import { ArrowIcon } from '@components/common/FormIcon';

interface HomecleanProps {
  handleClick: () => void;
  pageUrl: string;
}

const Homeclean = ({ handleClick, pageUrl }: HomecleanProps) => {
  const { isHomecleanIframeExpanded } = useRecoilValue(homecleanState);
  return (
    <Container isExpanded={isHomecleanIframeExpanded}>
      {isHomecleanIframeExpanded && (
        <IconWrapper>
          <IconButton onClick={handleClick}>
            <ArrowIcon />
          </IconButton>
        </IconWrapper>
      )}
      <HomecleanIframe src={pageUrl} isExpanded={isHomecleanIframeExpanded} />
      {!isHomecleanIframeExpanded && (
        <HomecleanButtonWrapper>
          <HomecleanButton onClick={handleClick}>날짜 선택하기</HomecleanButton>
        </HomecleanButtonWrapper>
      )}
    </Container>
  );
};

export default Homeclean;

interface HomecleanIframeProps {
  isExpanded?: boolean;
}

const Container = styled.div<HomecleanIframeProps>`
  width: ${({ isExpanded }) => (isExpanded ? '100vw' : '400px')};
  height: ${({ isExpanded }) => (isExpanded ? '100vh' : 'auto')};
  position: ${({ isExpanded }) => (isExpanded ? 'fixed' : 'absolute')};
  top: ${({ isExpanded }) => (isExpanded ? '0' : '30%')};
  left: ${({ isExpanded }) => (isExpanded ? '0' : '50%')};
  z-index: ${({ isExpanded }) => (isExpanded ? '999' : 'unset')};
  border: none;
  border-radius: 10px;
  background-color: white;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.15);
  transition: all 0.4s ease-in-out;

  @media (max-width: 420px) {
    width: ${({ isExpanded }) => (isExpanded ? '100vw' : '90vw')};
    left: ${({ isExpanded }) => (isExpanded ? '0' : '5%')};
    top: ${({ isExpanded }) => (isExpanded ? '0' : '280px')};
  }
`;

const IconWrapper = styled.div`
  padding: 24px 0 10px 30px;
  max-width: 700px;
  margin-right: auto;
  margin-left: auto;
  line-height: 1.7rem;
`;

const IconButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  width: 59.5px;
  text-align: left;

  &:active {
    background: none;
  }
`;

const HomecleanIframe = styled.iframe<HomecleanIframeProps>`
  width: 100%;
  height: ${({ isExpanded }) => (isExpanded ? '100vh' : '545px')};
  border: none;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  @media (max-width: 420px) {
    width: 100%;
    height: ${({ isExpanded }) => (isExpanded ? '100vh' : '545px')};
  }
`;

const HomecleanButtonWrapper = styled.div`
  width: 100%;
  border: none;
  padding: 16px 30px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`;

const HomecleanButton = styled(Button)`
  @media (max-width: 420px) {
    width: 100%;
  }
`;
